import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Shield, Heart, CheckCircle, MessageCircle, ArrowDown } from "lucide-react";
import { InterviewDialog } from "@/components/InterviewDialog";

const Hero = () => {
  const [isInterviewOpen, setIsInterviewOpen] = useState(false);

  return (
    <>
      <section className="hero-section bg-gradient-to-b from-secondary/75 to-background/40 py-12 md:py-20">
        <div className="hero-container">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="hero-heading text-balance font-heading text-primary mb-6">
              Machen Sie Ihre Immobilie zu Ihrer
              <span className="text-accent block mt-2">
                finanziellen Sicherheit
              </span>
            </h1>

            <p className="hero-lcp-text text-foreground text-xl md:text-2xl leading-relaxed mb-10 max-w-2xl mx-auto">
              Entdecken Sie bewährte Wege, das in Ihrer Immobilie gebundene
              Kapital zu nutzen – kostenlos und unabhängig beraten.
            </p>

            <div className="flex flex-col gap-4 max-w-md mx-auto mb-12">
              <Button
                variant="accent"
                size="lg"
                className="w-full text-lg md:text-xl py-5 min-h-[4rem] font-semibold"
                onClick={() =>
                  document
                    .getElementById("advisor-wizard")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
              >
                Kostenlosen Berater starten
                <ArrowDown className="ml-2 h-5 w-5" aria-hidden="true" />
              </Button>

              <Button
                variant="outline"
                size="lg"
                className="w-full text-lg md:text-xl py-5 min-h-[4rem] font-semibold"
                onClick={() => setIsInterviewOpen(true)}
              >
                <MessageCircle className="mr-2 h-5 w-5" aria-hidden="true" />
                Interview mit den Gründern
              </Button>
            </div>

            {/* Trust signals — single column on mobile, calmer */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl mx-auto">
              {[
                { icon: Shield, title: "100% Kostenlos", text: "Beratung ohne Kosten oder Verpflichtung" },
                { icon: Heart, title: "Vertrauensvoll", text: "Über 8.000 zufriedene Senioren" },
                { icon: CheckCircle, title: "Unabhängig", text: "Neutrale Empfehlungen – keine Provisionen" },
              ].map((item) => {
                const Icon = item.icon;
                return (
                  <div key={item.title} className="flex flex-col items-center text-center p-4">
                    <div className="bg-accent/15 p-4 rounded-2xl mb-3">
                      <Icon className="h-8 w-8 text-accent" aria-hidden="true" />
                    </div>
                    <h3 className="text-xl font-heading font-bold text-primary mb-1">
                      {item.title}
                    </h3>
                    <p className="text-base text-muted-foreground leading-snug">
                      {item.text}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <InterviewDialog open={isInterviewOpen} onOpenChange={setIsInterviewOpen} />
    </>
  );
};

export default Hero;
